import type { TStoryTagPosition } from '@/types/story-mode'

// Giữ đồng bộ với src/components/StoryModeSetting/constants.js bên coolmate-admin:
// admin preview thẻ 380x800 với tag rộng 300px và kẹp vị trí theo cùng công thức,
// nên toạ độ admin kéo thả khớp với chỗ tag hiển thị ở đây.
export const STORY_FRAME_W = 380
export const STORY_TAG_W = 300
const TAG_EDGE = 12
const TOP_MIN = 14
const TOP_MAX = 92

const DEFAULT_TOPS = [72, 30, 82, 40]

export const getDefaultTagPosition = (tagIndex: number): TStoryTagPosition => ({
  top: DEFAULT_TOPS[tagIndex % DEFAULT_TOPS.length],
  left: 50,
})

/**
 * Style định vị tag. `left` được kẹp bằng CSS clamp theo bề rộng thực của thẻ
 * (desktop 380px, mobile full màn hình) để tag 300px không tràn mép.
 */
export const getTagPositionStyle = ({ top, left }: TStoryTagPosition) => {
  const safeTop = Math.min(Math.max(top, TOP_MIN), TOP_MAX)
  const tagWidth = `min(${STORY_TAG_W}px, calc(100% - ${TAG_EDGE * 2}px))`
  const halfTag = `min(${STORY_TAG_W / 2}px, calc(50% - ${TAG_EDGE}px))`

  return {
    top: `${safeTop}%`,
    left: `clamp(calc(${halfTag} + ${TAG_EDGE}px), ${left}%, calc(100% - ${halfTag} - ${TAG_EDGE}px))`,
    width: tagWidth,
  }
}
